import React, { useState } from 'react';
import { cn } from '../lib/utils';
import { X, ZoomIn } from 'lucide-react';

export function ImageZoom({ src, alt = "Medical image", className = "" }) {
    const [open, setOpen] = useState(false);

    return (
        <>
            <div className={cn("relative group cursor-zoom-in", className)} onClick={() => setOpen(true)} data-testid="image-zoom-trigger">
                <img src={src} alt={alt} className="w-full max-h-80 object-contain" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                    <ZoomIn className="h-8 w-8 text-white opacity-0 group-hover:opacity-80 transition-opacity drop-shadow-lg" />
                </div>
            </div>
            {open && (
                <div className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4" onClick={() => setOpen(false)} data-testid="image-zoom-overlay">
                    <button className="absolute top-4 right-4 text-white/80 hover:text-white z-10 p-2" onClick={() => setOpen(false)} data-testid="image-zoom-close">
                        <X className="h-6 w-6" />
                    </button>
                    <img
                        src={src}
                        alt={alt}
                        className="max-w-[95vw] max-h-[90vh] object-contain select-none"
                        onClick={e => e.stopPropagation()}
                        data-testid="image-zoom-full"
                    />
                </div>
            )}
        </>
    );
}
